module.exports = __webpack_public_path__ + "img/section2Logo3.e1d658d4.png";